import { find, get } from "lodash";
import moment from "moment";
import React, { Component } from "react";
import Loadable from "react-loadable";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import * as newArticleAction from "~/actions/newArticle";
import Modal from "~/components/common/molecules/Modal";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import MenuBarBottom from "~/components/mobile/molecules/MenuBar";
import { partnerInfo } from "~/configs/partnerDetails";
import { requestAllFeatures } from "~/store/features/featuresActions";
import { clearDataSearchFeeCode } from "~/store/fee/feeActions";
import { resetFollowUpExam } from "~/store/followUpExam/actions";
import { requestHospitalList } from "~/store/hospital/hospitalActions";
import * as notificationAction from "~/store/notifications/notificationsActions";
import { clearState } from "~/store/patient/patientAction";
import { resetData, setPartnerId } from "~/store/totalData/actions";
import AppId from "~/utils/partner";
import { NOTI } from "~/utils/constants";
const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const HomePageDesktop = Loadable({
  loader: () => import("~/components/desktop/pages/Home"),
  loading: LoadableLoading
  // delay: 500
});

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      triggerModal: false,
      modalWarning: true
    };
    this.scrollTop = 0;
    this.menuBarBottomRef = React.createRef();
    if (this.props.IsAuthenticated) {
      this.props.getNotificationOnPage({
        category: 1
      });
    }
  }

  handleShowNotiModal = () => {
    const today = moment().format("YYYY/MM/DD");
    const triggerModal = moment(today).isSameOrBefore("2021-02-18");
    const wasTriggered = sessionStorage.getItem("isTriggerModal");
    if (!wasTriggered) {
      if (triggerModal) {
        this.setState({ triggerModal: true });
        sessionStorage.setItem("isTriggerModal", true);
      }
    }
  };

  handleHideNotiModal = () => {
    this.setState({ triggerModal: !this.state.triggerModal });
  };

  componentDidMount() {
    if (AppId === "dkanphuoc") {
      this.handleShowNotiModal();
    }
    this.props.resetData();
    this.props.resetFollowUpExam();
    this.props.clearDataSearchFeeCode();
    this.props.clearState();
    this.props.setPartnerId(AppId);
    this.props.requestAllFeatures();
    this.props.requestHospitalList();
  }

  render() {
    if (AppId === "momo") {
      return <Redirect to="/chon-benh-vien" />;
    }

    return (
      <React.Fragment>
        <HomePageDesktop
          {...this.props}
          menuBarBottomRef={this.menuBarBottomRef}
        />
        <MenuBarBottom
          menuBarBottomRef={this.props.menuBarBottomRef}
          currentLocation={this.props.location.pathname}
        />
        <Modal
          iconTitle={<i className="fal fa-bell" />}
          modal={this.state.triggerModal}
          toggle={() => this.handleHideNotiModal()}
          title="Thông báo"
          children={NOTI}
          centered
          className="centered"
        />
        <Modal
          iconTitle={<i className="fal fa-bell" />}
          modal={this.state.modalWarning}
          title="Thông báo"
          centered
          className="centered"
          footer
          footerConfirm
          cancelText=""
          okText="Gọi ngay"
          onOk={() => {
            window.open("tel:19002115", "_self");
          }}
          toggle={() => {
            this.setState({ modalWarning: false });
          }}
        >
          <p>Gọi 1900 2115 để được hỗ trợ.</p>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    user,
    notification,
    newArticle
  } = state;
  return {
    device: type,
    IsAuthenticated: user.IsAuthenticated,
    userInfo: user.info,
    notification,
    newArticle
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getNotificationOnPage: data =>
      dispatch(notificationAction.getNotificationOnPage(data)),
    getNotification: data => dispatch(notificationAction.getNotification(data)),
    getFeaturedArticle: () => dispatch(newArticleAction.getFeaturedArticle()),
    requestAllFeatures: () => dispatch(requestAllFeatures()),
    resetData: () => dispatch(resetData()),
    resetFollowUpExam: () => dispatch(resetFollowUpExam()),
    clearDataSearchFeeCode: () => dispatch(clearDataSearchFeeCode()),
    setPartnerId: id => dispatch(setPartnerId(id)),
    requestHospitalList: () => dispatch(requestHospitalList()),
    clearState: () => dispatch(clearState())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
